var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center logo-wrapper d-flex flex-column"},[_c('div',[_c('img',{staticStyle:{"width":"150px","height":"150px"},attrs:{"src":_vm.settings.logo,"alt":"Footer Logo"}})]),_c('span',[_vm._v("A division of TAL Holdings LLC")])])
}
var staticRenderFns = []

export { render, staticRenderFns }